<header>
  <h1>Finance Admin</h1>
</header>
<section class="filters">
  <button
    mat-stroked-button
    (click)="exportRange()"
    color="primary"
    matTooltip="Export date range."
    >
    <mat-icon>file_download</mat-icon>
    Export Batches
  </button>
</section>
<section>
  @if (loading) {
    <mat-card class="loading">
      <mat-card-content>
        <mat-icon>autorenew</mat-icon>
        Loading...
      </mat-card-content>
    </mat-card>
  }
  @if (!loading) {
    @if (!Batches?.length) {
      <mat-card class="no-results">
        <mat-card-content>
          <mat-icon>sentiment_dissatisfied</mat-icon>
          No batches found.
        </mat-card-content>
      </mat-card>
    }
    @if (!!Batches?.length) {
      <mat-table #table [dataSource]="DataSource">
        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
          <mat-cell *matCellDef="let row"
            >{{row.header[4] | date: 'EEEE, MMMM d y'}}</mat-cell
            >
          </ng-container>
          <ng-container matColumnDef="total">
            <mat-header-cell *matHeaderCellDef>Total</mat-header-cell>
            <mat-cell *matCellDef="let row"
              >{{row.header[2] | currency : 'GBP' : 'symbol-narrow'}}</mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="order">
              <mat-header-cell *matHeaderCellDef>Order</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.header[3]}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
              <mat-cell *matCellDef="let row" class="actions">
                <button
                  (click)="viewProduct(row)"
                  mat-icon-button
                  matTooltip="View product"
                  >
                  <mat-icon>list</mat-icon>
                </button>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
          @if (PageEvent) {
            <mat-paginator
              (page)="DataSource.loadWithPageEvent($event)"
              [length]="PageEvent.length"
              [pageIndex]="PageEvent.pageIndex"
              [pageSize]="PageEvent.pageSize"
            ></mat-paginator>
          }
        }
      }
    </section>
